import styled from 'styled-components'
import { colors } from 'styles/colors'

import { Container as BaseContainer, Link } from './style'
import { mobile } from 'styles/responsive'

export const Container = styled(BaseContainer)`
    position: relative;

    ${mobile(`
        overflow: hidden;
    `)}
`

export const Content = styled.div`
    max-width: 1110px;
    display: flex;
    justify-content: center;
    text-align: left;
    padding: 0 20px;

    > * + * {
        margin-left: 30px;
    }

    ${mobile(`
        flex-direction: column;

        > * + * {
            margin-left: 0;
        }

        .img-wrap {
            width: 80%;
            align-self: flex-end;
        }

        .hero {
            width: 100%;
        }
    `)}
`

export const Info = styled.div`
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 25px;
    }
`

export const Subtitle = styled.h2`
    position: relative;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    color: ${colors.blue3};

    &:before {
        content: '';
        position: absolute;
        height: 5px;
        width: 10%;
        background-color: ${colors.lightBlue};
        border-radius: 4px;
        bottom: -15px;
    }

    ${mobile(`
        font-size: 18px;
        line-height: 1.5;
        padding-top: 50px;
    `)}
`

export const Desc = styled.span`
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;

    color: ${colors.black};

    ${mobile(`
        font-size: 16px;
        line-height: 1.2;
    `)}
`

export const Background = styled.img`
    position: absolute;
    width: 1000px;

    top: -70px;
    left: -350px;
    z-index: -10;

    ${mobile(`
        top: 5px;
        left: -110px;
        width: 140%;
    `)}
`

export const LinkButton = styled(Link)`
    ${mobile(`
        display: flex;
        padding: 0 20px;
        margin-top: 30px;

        button {
            padding-top: 20px !important;
            padding-bottom: 20px !important;
            flex-grow: 1;
        }    
    `)}
`
